<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Notifiche Push</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-text-justify">
  <div class="ion-margin">
    <ion-text>
      <p>
        Le notifiche push permettono di ricevere in tempo reale i messaggi inviati nelle chat dai
        partecipanti direttamente sul proprio computer o smartphone analogamente a come avviene
        nelle applicaizoni di messaggistica come WhatsApp o Telegram.
      </p>
      <p>
        Le notifiche possono arrivare anche se il browser non è in primo piano o è stato chiuso
        (dipende dalla configurazione del browser). In questo caso, le notifiche verranno mostrate
        come banner in basso o in alto a desta dello schermo.
      </p>

      <h3>Attivazione</h3>

      <p>
        Per attivare la ricezione delle notifiche è sufficiente accettare cliccando sul bottone del
        messaggio presente in cima alla pagina corrente o in fondo a questo popup.
      </p>
      <p>In alternativa:</p>
      <ul>
        <li>
          Clicca sulla prima icona (a forma di lucchetto 🔒 o punto informativo 🛈) all'inizio della
          barra degli indirizzi

          <img
            src="assets/messages/notif/address-bar.svg"
            height="72"
            alt="Descrizione posizione permessi nella barra degli indirizzi"
          />
        </li>

        <li>Alla voce "Notifiche", scegli <strong>"consenti"</strong> dal menù a tendina</li>

        <li>Ricarica la pagina</li>
      </ul>
      <p><strong>Nota:</strong> Non tutti i browser supportano le notifiche push.</p>

      <h3>Disattivazione</h3>

      <p>
        Se non si vuole più ricevere notifiche push, è possibile disabilitarle delle impostazioni
        del browser. Ogni browser prevede una procedura differente. Per maggiori informazioni visita
        i link sottostanti:
      </p>
    </ion-text>

    <ion-list>
      <ion-item
        href="https://support.google.com/chrome/answer/3220216?co=GENIE.Platform%3DDesktop&hl=it"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ion-label>Chrome</ion-label>
      </ion-item>

      <ion-item
        href="https://support.mozilla.org/it/kb/notifiche-push"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ion-label>Firefox</ion-label>
      </ion-item>

      <ion-item
        href="https://www.windowsblogitalia.com/2016/11/bloccare-notifiche-microsoft-edge/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <ion-label>Edge</ion-label>
      </ion-item>
    </ion-list>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <span>Ok</span>
      </ion-button>

      <ion-button (click)="onDismiss(true)" color="primary" *ngIf="showEnableBtn">
        <span>Abilita Notifiche</span>
        <ion-icon [src]="'bell-outline' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
